
let inject = [
  '$scope',
  'QuotationsService',
  '$state',
  '$rootScope',
  'SharedService',
  '$timeout',
  'ngAuthSettings',
  'SessionService',
  'NgTableParams',
  '$uibModal',
  '$stateParams',
  'ServiceOrdersService'
];
class QuotationsController {
  constructor($scope,
    QuotationsService,
    $state,
    $rootScope,
    SharedService,
    $timeout,
    ngAuthSettings,
    SessionService,
    NgTableParams,
    $uibModal,
    $stateParams,
    ServiceOrdersService) {
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.SessionService = SessionService;
    this.ngAuthSettings = ngAuthSettings;
    this.NgTableParams = NgTableParams;
    // this.$scope = $scope;
    this.$timeout = $timeout;
    this.$rootScope = $rootScope;
    this.QuotationsService = QuotationsService;
    this.ServiceOrdersService = ServiceOrdersService;
    this.$uibModal = $uibModal;
    this.SharedService = SharedService;

    this.quotationsList = null;
    this.stateQuotations = {};
    this.ngTableConfigQuotations = null;
    this.ngTableColsQuotations = null;

    this.quotationDetail = null;
    this.stateQuotationDetail = {};
    this.ngTableConfigQuotationDetail = null;
    this.ngTableColsQuotationDetail = null;
    this.currentQuote = {};

    this.wachingDetailQuotation = false;

    this.payment = {};
    this.payment.recaudo = 0;
    this.payment.recaudo_total = 0;

    this.orderServiceId = this.$stateParams.orderServiceId || null;
  }

  $onInit() {
    this.getQuotationsHead();
  }

  //encabezado de la cotizacion
  getQuotationsHead() {

    this.stateQuotations.loading = true;
    this.wachingDetailQuotation = false;
    this.$timeout(() => {
      if (this.quotationsList && this.quotationsList.length > 0) {
        this.stateQuotations.loading = false;
        this.stateQuotations.loaded = true;
      } else {
        //this.shCtrl.globals.currentUser.thirdDocumentNumber
        let promiseQuotations = (this.orderServiceId ? this.ServiceOrdersService.getServiceOrdersDetail(this.orderServiceId) : this.QuotationsService.getQuotationsHead(this.shCtrl.globals.currentUser.thirdDocumentNumber));
        promiseQuotations.then((response) => {
          this.stateQuotations.loading = false;
          this.stateQuotations.loaded = true;
          if (response.length) {
            if (this.orderServiceId) {
              response.splice((response.length - 1), 1);
            }

            this.quotationsList = response;
            this.quotationsList.forEach((value, index) => {
              value.valor_doc = parseInt(value.total);
            })
            //this.quotationsList = cabeceraData;
            console.log(response);
            this.initNgTableQuotations();
          }

        }).catch((reason) => {
          this.stateQuotations.loading = false;
          this.stateQuotations.loaded = true;
          this.stateQuotations.error = true;
        });
      }

    }, 1000);
  }

  changeValor(row) {
    let valorServiceOrder = angular.copy(parseInt(row.valor_pagar_hoy.replace(/,/g, '')));




    if (valorServiceOrder > row.valor_pendiente) {
      row.valor_pagar_hoy = (row.valor_pendiente*30)/100;
      valorServiceOrder = (row.valor_pendiente * 30)/100;
    }else if(valorServiceOrder < ((row.valor_pendiente *30)/100)){
      
      row.valor_pagar_hoy = ( row.valor_pendiente*30)/100;
      valorServiceOrder = (row.valor_pendiente * 30)/100;
    }

    this.payment.recaudo_total -= row.valor_pagar_hoy_before;
    this.payment.recaudo_total += valorServiceOrder;

    row.detalle_saldo_documento = (row.detalle_valor_documento - valorServiceOrder);
    row.valor_pagar_hoy_before = valorServiceOrder;
    row.valor_pagar_hoy = parseInt(row.valor_pagar_hoy.replace(/,/g, ''));

  }

  activateQuotation(row) {
    console.log(row);
    if (row.activate) {
      row.valor_pagar_hoy = (row.valor_pendiente *30)/100;
      row.valor_pagar_hoy_before = (row.valor_pendiente *30)/100;
      this.payment.recaudo_total += (row.valor_pendiente *30)/100;

    } else {
      this.payment.recaudo_total -= row.valor_pagar_hoy_before;
      row.valor_pagar_hoy =(row.valor_pendiente *30)/100;
      row.valor_pagar_hoy_before = (row.valor_pendiente *30)/100;
    }
  }

  initNgTableQuotations() {
    /**
     * name:                           "NCN-000024"
     * type:                             "Lorem Ipsum"
     * fecha_cotizacion:                 "2016-09-14"
     * validez_cotizacion:               "2016-09-14"
     * assigned_user_name:               "Lorem Ipsum"
     * valor_saldo:                      "0.0000"
     * valor_pendiente:                  "0.0000"
     * valor_pagar_hoy:                  "0.0000"
     * total:                            "0.0000"
     */
    this.ngTableColsQuotations = [
      {
        field: "name",
        title: "No.",
        // sortable: "name",
        filter: { "name": "text" },
        show: true
      },
      {
        field: "fecha_cotizacion",
        title: "F. Elaboración",
        // sortable: "fecha_cotizacion",
        filter: { "fecha_cotizacion": "text" },
        show: true
      },
      {
        field: "validez_cotizacion",
        title: "F. Vencimiento",
        // sortable: "validez_cotizacion",
        filter: { "validez_cotizacion": "text" },
        show: true
      },
      {
        field: "assigned_user_name",
        title: "Vendedor",
        // sortable: "assigned_user_name",
        filter: { "assigned_user_name": "text" },
        show: true
      },

      {
        field: "subtotal",
        title: "Subtotal",
        // sortable: "subtotal",
        filter: { "subtotal": "text" },
        show: true
      },
      {
        field: "impuestos",
        title: "Iva",
        // sortable: "impuestos",
        filter: { "impuestos": "text" },
        show: true
      },
      {
        field: "valor_doc",
        title: "Vr. Doc.",
        // sortable: "valor_doc",
        filter: { "valor_doc": "text" },
        show: true
      },
      /*{
        field: "valor_pagar_hoy",
        title: "Vr. a pagar hoy",
        show: true
      },*/
      /*{
        field: "selection",
        title: "",
        show: true
      },*/
      {
        field: "actions",
        title: "Acciones",
        show: true
      }
    ];

    let initialParams = {
      count: 20,
      sorting: { fecha_cotizacion: "desc" }
    };

    let initialSettings = {
      counts: [5, 10, 20],
      paginationMaxBlocks: 8,
      paginationMinBlocks: 2,
      dataset: this.quotationsList
    };

    this.ngTableConfigQuotations = new this.NgTableParams(initialParams, initialSettings);
  }


  //funcion del detalle de la cotizacion

  getQuotationDetail(document) {
    this.payment.recaudo = 0;
    this.currentQuote.number = document.name;
    this.currentQuote.value = document.valor_doc;
    this.currentQuote.elaborationDate = document.fecha_cotizacion;
    this.currentQuote.expirationDate = document.validez_cotizacion;
    this.currentQuote.assigned_user_name = document.assigned_user_name;
    this.wachingDetailQuotation = true;
    this.stateQuotationDetail.loading = true;
    //this.$timeout(()=>{
    this.QuotationsService.getQuotationsDetail(document.name).then((response) => {
      this.stateQuotationDetail.loading = false;
      this.stateQuotationDetail.loaded = true;
      this.quotationDetail = response;
      this.payment.recaudo_total = 0;
      this.quotationDetail.forEach((value, index) => {
        value.detalle_numero_documento = document.name;
        value.assigned_user_name = response.assigned_user_name;
        if (value.descripcion_item.length > 30) {
          value.descriptionShort = value.descripcion_item.slice(0, 30) + '...';
          value.short = true;
        } else {
          value.descriptionShort = value.descripcion_item;
          value.short = false;
        }
        value.vr_unit = parseInt(value.vr_unit);
        value.cantidad = parseInt(value.cantidad);
        value.vr_total = parseInt(value.vr_total);
        value.porcentaje_descuento = parseInt(value.porcentaje_descuento);
        value.descuento_moneda = parseInt(value.descuento_moneda) || (value.vr_unit * (value.porcentaje_descuento / 100));
        value.impuestos = parseInt(value.impuestos);
        value.valor_pendiente = parseInt(value.vr_total);
        value.valor_pagar_hoy = (value.vr_total * 30) / 100;
        value.valor_pagar_hoy_before = (value.vr_total * 30) / 100;
        this.payment.recaudo += value.valor_pendiente;
        value.type = "Cotización";

        this.shCtrl.globals.currentClient.payCart.forEach(val => {
          if (value.type == "Cotización") {
            if (value.detalle_numero_documento == val.detalle_numero_documento) {
              if (value.referencia == val.referencia) {
                value.activate = true;
                value.valor_pagar_hoy = val.valor_pagar_hoy;
              value.valor_pagar_hoy_before = val.valor_pagar_hoy_before;
              value.valor_pendiente = val.valor_pendiente;
                this.payment.recaudo_total += val.valor_pagar_hoy;
              }
            }
          } 
        });

      });


      this.initNgTableQuotationDetail();
    }).catch((reason) => {
      this.stateQuotationDetail.loading = false;
      this.stateQuotationDetail.loaded = true;
      this.stateQuotationDetail.error = true;
    });
    //}, 1000);
  }
  //Tabla del detalle de cotizacion
  initNgTableQuotationDetail() {
    /**
     * nombre:                     "Estufa verde a gas"
     * referencia:                 "981323"
     * cantidad:                   "5"
     * unidad_medida:              "BOLSA"
     * vr_unit:                    "0.0000"
     * descuento:                  "0.0000"
     * porcentaje_descuento:       "5%"
     * impuestos:                  "0.0000"
     * vr_total:                   "0.0000"
     */

    this.ngTableColsQuotationDetail = [
      {
        field: "descriptionShort",
        title: "Nombre",
        // sortable: "descriptionShort",
        filter: { "descriptionShort": "text" },
        show: true
      },
      {
        field: "referencia",
        title: "Ref.",
        // sortable: "referencia",
        filter: { "referencia": "text" },
        show: true
      },
      {
        field: "cantidad",
        title: "Cant.",
        filter: { "cantidad": "text" },
        show: true
      },
      {
        field: "unidad_medida",
        title: "U.M.",
        filter: { "unidad_medida": "text" },
        show: true
      },
      {
        field: "vr_unit",
        title: "Vr. Unit.",
        // sortable: "vr_unit",
        filter: { "vr_unit": "text" },
        show: true
      },
      {
        field: "descuento_moneda",
        title: "Vr. Desc",
        // sortable: "descuento_moneda",
        filter: { "descuento_moneda": "text" },
        show: true
      },
      {
        field: "porcentaje_descuento",
        title: "% Desc",
        // sortable: "porcentaje_descuento",
        filter: { "porcentaje_descuento": "text" },
        show: true
      },
      {
        field: "impuestos",
        title: "Iva",
        filter: { "impuestos": "text" },
        show: true
      },
      {
        field: "vr_total",
        title: "Total",
        // sortable: "vr_total",
        filter: { "vr_total": "text" },
        show: true
      },
      {
        field: "valor_pagar_hoy",
        title: "Vr. a pagar hoy",
        filter: { "valor_pagar_hoy": "text" },
        show: true
      },
      {
        field: "selection",
        title: "Seleccionar",
        filter: { "selection": "text" },
        show: true
      },
    ];

    let initialParams = {
      count: 20
    };

    let initialSettings = {
      counts: [5, 10, 20],
      paginationMaxBlocks: 8,
      paginationMinBlocks: 2,
      dataset: this.quotationDetail
    };

    this.ngTableConfigQuotationDetail = new this.NgTableParams(initialParams, initialSettings);
  }

  //agregar al carrito
  addPayment() {
    let result = angular.copy(this.quotationDetail.filter(val => { return val.activate; }));

    let globalsData = angular.copy(this.shCtrl.globals);
    if (result.length) {
      result.forEach(val => {
        globalsData.currentUser.payCart.forEach((value, key) => {
          if (val.detalle_numero_documento == value.detalle_numero_documento) {
            if (val.referencia == value.referencia) {
              globalsData.currentUser.totalCartPay -= value.valor_pagar_hoy;
              globalsData.currentUser.payCart.splice(key, 1);
            }
          }
        });
      });
      result.forEach(value => {
        value.detalle_valor_documento = value.vr_total;
      });
      globalsData.currentUser.totalCartPay = this.payment.recaudo_total;
      globalsData.currentUser.payCart.forEach(val => {
        result.push(val);
        globalsData.currentUser.totalCartPay += val.valor_pagar_hoy;
      });

      // globalsData.currentUser.payCart = result;
      this.shCtrl.globals.currentUser.payCart = result
      this.shCtrl.globals.currentUser.totalCartPay = globalsData.currentUser.totalCartPay;
      this.SessionService.put('globals', this.shCtrl.globals);
      //  this.payment.recaudo_total = 0;
      angular.copy(this.shCtrl.globals.currentUser, this.shCtrl.globals.currentClient);
      this.notification = true;
      this.wachingDetailQuotation = false;

      this.$timeout(() => {
        // this.shCtrl.globals.currentUser.activeTap = 3;
        this.notification = false;
      }, 3000);
    } else {
      alert('Debe seleccionar al menos un items de la cotización a pagar');
    }
  }
}

QuotationsController.$inject = inject;

export default QuotationsController;




/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/payments-advances/quotations/quotations.controller.js
 **/